import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PasswordlessAccessCommand } from 'app/library/passwordless-access/models/passwordless-access.command.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IModulePasswordlessAccessAndTotalCount } from '../../interfaces/module-passwordless-access-pagination.query';
import { IModulePasswordlessAccessQuery } from '../../interfaces/module-passwordless-access.query.interface';
import { CreateModulePasswordlessAccessModel } from '../../models/create-module-passwordless-access';
import { ModulePasswordlessAccess } from '../../models/module-passwordless-access.model';

@Injectable()
export class ModulePasswordlessAccessApiService {
    entities = 'modules/passwordless-accesses';

    constructor(private _http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private _environment: IEnvironment) {}

    getAll(moduleId: string, pageSize = 10, pageIndex = 1, search = ''): Observable<IModulePasswordlessAccessAndTotalCount> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString());

        if (search) {
            params = params.set('filter[query]', search);
        }

        return this._http.get<IModulePasswordlessAccessAndTotalCount>(`${this._environment.apiUrl}/modules/${moduleId}/passwordless-accesses`, { params });
    }

    create(entity: CreateModulePasswordlessAccessModel): Observable<ModulePasswordlessAccess[]> {
        const data = new PasswordlessAccessCommand(entity);

        return this._http
            .post<IModulePasswordlessAccessQuery[]>(`${this._environment.apiUrl}/${this.entities}/bulk`, data)
            .pipe(map((queries) => queries.map((query) => new ModulePasswordlessAccess(query))));
    }
}
